var _excluded = ["type", "size", "isDisabled", "isReadOnly", "isInverted"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { icons, useIconAsset, useIcons } from '../../../theme';
import { forwardRef } from '../../../utils';
import { useStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../Box';
import { iconColorMapping } from './_BaseIcon.types';
import { jsx as _jsx } from "react/jsx-runtime";

function isRegularIcon(icon) {
  return !!icon && Object.keys(icons).includes(icon);
}
/**
 * @private For internal use only.
 */


export var _BaseIcon = forwardRef((_ref, ref) => {
  var {
    type,
    size,
    isDisabled,
    isReadOnly,
    isInverted = false
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useStyleConfig('BaseIcon', {
    size,
    isInverted
  });
  var icons = useIcons();
  var icon = useIconAsset(type, size);
  var baseIcon = isRegularIcon(type) ? icon : icons[type];
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    as: "span",
    "data-component": "_BaseIcon",
    __css: styles,
    role: "img",
    "aria-label": "".concat(type, "-icon"),
    ref: ref,
    "data-disabled": isDisabled || undefined,
    "data-readonly": isReadOnly || undefined,
    "data-is-brand-color": iconColorMapping['brand'] === props.color
  }, props), {}, {
    children: /*#__PURE__*/_jsx(Box, {
      as: baseIcon
    })
  }));
});
_BaseIcon.displayName = '_BaseIcon';
//# sourceMappingURL=_BaseIcon.js.map